import { Address, encodePacked, fromHex, toHex } from 'viem'
import { ChainId } from './interfaces'

export type A160U96 = bigint & { __brand: 'A160U96' }

export const createA160U96 = (address: Address, value: bigint): A160U96 =>
  ((value << BigInt(160)) | fromHex(address, 'bigint')) as A160U96

export const fromA160U96 = (a: bigint | string): { address: Address; value: bigint } => {
  const value = BigInt(a) >> BigInt(160)
  const address = BigInt(a) & BigInt('0xffffffffffffffffffffffffffffffffffffffff')

  return { address: toHex(address, { size: 20 }), value }
}

// INFO: Airdrop
export const createAirdropOptions = (
  gas: bigint,
  airdropAmount: bigint,
  airdropRecipient: Address,
) =>
  encodePacked(
    ['uint16', 'uint256', 'uint256', 'address'],
    [2, gas, airdropAmount, airdropRecipient],
  )

export const isChainId = (chainId: number, chainIds: number[]): chainId is ChainId =>
  Object.values(chainIds).some((id) => id === chainId)

export const toChainId = (chainId: bigint, chainIds: number[]): ChainId => {
  const chainIdNumber = Number(chainId)
  if (isChainId(chainIdNumber, chainIds)) {
    return chainIdNumber as ChainId
  } else {
    throw `Invalid chainId: ${chainIdNumber}`
  }
}
